import { useCheckPermission } from './useUserRoles';

/**
 * PROJECTS STAKEHOLDERS Permissions Hooks
 * 
 * ⚠️ IMPORTANT: This is for PROJECTS Stakeholders module ONLY (table: stakeholders)
 * For CRM module (localStorage-based), use useCRMPermissions.tsx instead.
 * 
 * Namespace: STAKEHOLDERS_* permissions with granular access control
 */

export const useStakeholdersAccess = () => {
  return useCheckPermission('STAKEHOLDERS_ACCESS');
};

export const useStakeholdersViewPermissions = () => {
  const canViewList = useCheckPermission('STAKEHOLDERS_VIEW_LIST');
  const canViewDetails = useCheckPermission('STAKEHOLDERS_VIEW_DETAILS');
  
  return { 
    list: canViewList.data || false, 
    details: canViewDetails.data || false,
    isLoading: canViewList.isLoading || canViewDetails.isLoading
  };
};

export const useStakeholdersEditPermissions = () => {
  const canCreate = useCheckPermission('STAKEHOLDERS_CREATE');
  const canEdit = useCheckPermission('STAKEHOLDERS_EDIT');
  const canDelete = useCheckPermission('STAKEHOLDERS_DELETE');
  
  return { 
    create: canCreate.data || false, 
    edit: canEdit.data || false, 
    delete: canDelete.data || false,
    isLoading: canCreate.isLoading || canEdit.isLoading || canDelete.isLoading
  };
};

export const useStakeholdersManagePermissions = () => {
  const canAssign = useCheckPermission('STAKEHOLDERS_ASSIGN_PROJECTS');
  const canManage = useCheckPermission('STAKEHOLDERS_MANAGE_ASSIGNMENTS');
  const canDuplicate = useCheckPermission('STAKEHOLDERS_DUPLICATE');
  
  return { 
    assign: canAssign.data || false, 
    manage: canManage.data || false,
    duplicate: canDuplicate.data || false,
    isLoading: canAssign.isLoading || canManage.isLoading || canDuplicate.isLoading
  };
};